<template>
  <v-dialog v-model="dialog" width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        color="#ffffff"
        width="112"
        height="38"
        class="btn-739eec"
      >
        현장선택
      </v-btn>
    </template>
    <v-card class="max-height-600">
      <v-card-title class="text-h5 back-556C96 lighten-2">
        <h4 class="color-white">현장선택</h4>
        <v-spacer />
        <v-icon color="white" @click="dialog = !dialog"> mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="justify-center d-flex">
        <perfect-scrollbar style="max-height:360px" class="mt-3">
          <v-radio-group
            v-model="construction"
            v-if="constructionList"
            multiple
            row
          >
            <v-radio
              color="primary"
              class="width-float pa-2 pr-5 "
              v-for="list in constructionList"
              :key="list.constructionId"
              :label="list.constructionName"
              :value="list"
              style="width:165px;"
            >
            </v-radio>
          </v-radio-group>
        </perfect-scrollbar>
      </v-card-text>
      <v-card-actions class="justify-center align-center pb-5">
        <v-btn
          color="#3F557D"
          class="color-white"
          width="150"
          height="40"
          @click="construction = []"
        >
          다시선택하기
        </v-btn>
        <v-btn
          color="#3F557D"
          class="color-white"
          width="150"
          height="40"
          @click="selectConstruction"
        >
          선택완료
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ConstructionApi from "@/api/ConstructionService";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
export default {
  components: {
    PerfectScrollbar,
  },

  watch: {
    dialog: async function() {
      let returnData = await ConstructionApi.constructionTotalList({
        constructionId: 0,
      });
      this.constructionList = returnData.data.constList;
    },
  },

  methods: {
    selectConstruction() {
      this.dialog = false;
      this.$bus.$emit("sendConstruction", this.construction);
      this.construction = [];
    },
  },

  data: function() {
    return {
      dialog: false,
      tempList: [],
      constructionList: [],
      construction: [],
    };
  },
};
</script>

<style scoped>
.width-float {
  width: 30%;
}
</style>
